module.exports = __webpack_public_path__ + "img/keleteyi.61df1ef5.png";